import { AuthScreen } from './AuthScreen';

export function LoginPage() {
  return <AuthScreen />;
}
